import { IExtractionCellForm } from '_/types/extractionCells/extractionCells.types';
import slugValidator from '_/utils/validation/slugValidator';
import * as Yup from 'yup';

export const EXTRACTION_CELL_INITIAL_VALUES: IExtractionCellForm = {
  availabilityZone: '',
  cellNumber: '',
  active: true,
  slug: '',
};

export const extractionCellValidationSchema = (extractionCells: Array<IExtractionCellForm>) => (): Yup.AnySchema =>
  Yup.object().shape({
    slug: slugValidator(extractionCells, 'An extraction cell'),
    availabilityZone: Yup.string().required(),
    cellNumber: Yup.string()
      .required()
      .test('isCellNumberValid', (cellNumber: string, { createError }) =>
        cellNumber?.length !== 2 ? createError({ message: 'Cell Number must be 2 characters' }) : true,
      ),
    active: Yup.boolean(),
  });
